import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { formatIsoDay, formatNumber } from "@/lib/format";
import { StatusBadge } from "@/lib/orders";
import { Stat, sel } from "@/lib/finance";
import { EmptyRow, LoadingRow, PageHeader } from "@/components/common/States";
import PickScreen from "@/components/depo/PickScreen";

const STEPS = [["stok_ayrildi", "Toplanacak"], ["toplaniyor", "Toplanıyor"], ["kontrol", "Kontrol"], ["paketlendi", "Paketleme"]];

export default function Depo() {
  const [params, setParams] = useSearchParams();
  const [wh, setWh] = useState("");
  const [st, setSt] = useState("");
  const [res, setRes] = useState(null);
  const id = params.get("id");
  useEffect(() => { if (!id) { setRes(null); api.get("/depo/queue", { params: { warehouse_id: wh } }).then(({ data }) => setRes(data)); } }, [wh, id]);
  if (id) return <div data-testid="depo-page"><PickScreen id={id} onBack={() => setParams({})} /></div>;
  const items = (res?.items || []).filter((i) => !st || i.status === st);
  return (
    <div data-testid="depo-page">
      <PageHeader title="Depo · Toplama Kuyruğu" subtitle="Siparişi seçin, barkod okutarak toplayın, kontrol edin ve paketleyin" testid="depo-title">
        <select className={`${sel} h-10 text-base`} value={wh} onChange={(e) => setWh(e.target.value)} data-testid="depo-warehouse-select">
          <option value="">Tüm depolar</option>{(res?.warehouses || []).map((w) => <option key={w.id} value={w.id}>{w.name}</option>)}
        </select>
      </PageHeader>
      {res?.disabled && <div className="panel p-6 mb-4 text-slate-600 border-amber-300 bg-amber-50" data-testid="depo-disabled">{res.message}</div>}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {STEPS.map(([k, l]) => <Stat key={k} label={l} value={res?.counts?.[k] ?? "—"} hint="sipariş" active={st === k} onClick={() => setSt(st === k ? "" : k)} testid={`depo-count-${k}`} />)}
      </div>
      <div className="panel overflow-x-auto">
        <table className="erp-table text-[15px]" data-testid="depo-queue-table">
          <thead><tr><th>Sipariş</th><th>Tarih</th><th>Cari</th><th className="text-right">Kalem</th><th className="text-right">Adet</th><th className="text-right">İlerleme</th><th>Durum</th></tr></thead>
          <tbody>
            {!res ? <LoadingRow cols={7} /> : items.length === 0 ? <EmptyRow cols={7} text="Kuyrukta sipariş yok" /> : items.map((o) => (
              <tr key={o.id} className="cursor-pointer h-14" onClick={() => setParams({ id: o.id })} data-testid={`depo-queue-row-${o.order_no}`}>
                <td className="font-mono font-semibold">{o.order_no}</td><td className="font-mono text-xs">{formatIsoDay(o.order_date)}</td>
                <td className="max-w-[260px] truncate">{o.customer_title}</td><td className="text-right font-mono">{o.line_count}</td>
                <td className="text-right font-mono">{formatNumber(o.qty)}</td>
                <td className="text-right font-mono text-xs">{o.status === "kontrol" ? `Kontrol ${formatNumber(o.verified)}/${formatNumber(o.qty)}` : `${formatNumber(o.picked)}/${formatNumber(o.qty)}`}</td>
                <td><StatusBadge status={o.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
